import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html'
import { decryptData } from '../utils/crypt'
import useCsrfToken from '../hooks/useCsrfToken';

Directorioshort.propTypes = {
    listingid: PropTypes.string,
};

export default function Directorioshort({ listingid }) {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const stripTagsFromHtml = (html) => {
            const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
            return sanitizeHtml(html, {
                allowedTags: allowedTags
            });
        };
        const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;
        const domesticDecryptdata = (data) => {
            return decryptData(data, secretKey);
        };
        const transformData = (data) => {
            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Tecnología y equipamiento',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description?.length > 100 ? stripTagsFromHtml(data.description).substring(0, 100) + '...' : stripTagsFromHtml(data.description),
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1 !== null ? domesticDecryptdata(data.phone_1) : '',
                title: data.title,
                listing_type: data.listing_type,
                embed: data.embed,
                cta_icon: data.cta_icon,
                specialty: data.specialty_title
            };
        };
        if (!listingid) return;
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings-by-tag/${listingid}/directory`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    if (data.length && !data.error) {
                        const transformedListings = data.map(item => transformData(item));
                        setListings(transformedListings);
                        // console.log('transformedListings', transformedListings);
                    }

                })
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [listingid, csrfToken]);
    return (
        <>
            {listings && listings.length > 0 && (
                <section className="section">
                    <div className="container mt-20">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="section-title text-center mb-2 pb-1">
                                    <h4 className="title mb-3">Algunos especialistas relacionados</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {listings.slice(0, 3).map((item, index) => {
                                return (
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                                        <div className="directorymini position-relative overflow-hidden rounded p-2">
                                            <div className="position-relative">
                                                <div className="card team team-primary bg-transparent text-center mb-5">
                                                    <div className="card-img team-image d-inline-block mx-auto rounded overflow-hidden">
                                                        <Link to={`/directorio/${item.slug}`} className="text-dark mb-0 title">
                                                            <img src={item.image} className="img-fluid" alt="" />
                                                        </Link>
                                                    </div>
                                                    <div className="content bg-white mx-4 p-2 z-1 rounded shadow">
                                                        <Link to={`/directorio/${item.slug}`} className="text-dark mb-0 title">{item.name}</Link>
                                                        <br />
                                                        <small className="text-muted mb-0 mt-1 fw-normal">{item.specialty}</small>
                                                        <a className="btn btn-sm p-1 btn-dark mt-2 w-100" href={`tel:${item.phone_1}`}>Llamar</a>
                                                        <a className="btn btn-sm p-1 btn-dark mt-2 w-100" href={`/directorio/${item.slug}`}>Ver</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="row justify-content-center mt-4">
                            <div className="col-12 text-center">
                                <a href="/directorio" className="btn btn-link text-primary fs-6">Ver más <i className="mdi mdi-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}
